// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2yRZf","row":"styles_row__lQq-k"};